import { Vraag } from '@models/claims';

export class MetenMapper {
  public static format(titel: string): string {
    if (!titel || titel.length === 0) {
      return '';
    }
    return titel.toLowerCase()
      .replace('&shy;', '')
      .replace(/\s/g, '_')
      .replace(/-/g, '_')
      .replace(/[^\wéë]/g, '')
      .replace(/__/g, '_')
      .replace(/_$/, '');
  }

  public static formatTitelMetToevoeging(titel: string, titel_toevoeging): string {
    return this.format(this.titelToevoegingWeg(titel, titel_toevoeging));
  }

  public static formatGA(titel: string): string {
    if (!titel || titel.length === 0) {
      return '';
    }
    return titel.toLowerCase()
      .replace('&shy;', '')
      .replace(/_/g, ' ')
      .replace(/[^\w\séë]/gi, '')
      .replace(/\s/g, '-')
      .replace(/--/g, '-')
      .replace(/-$/, '');
  }

  public static formatGATitelMetToevoeging(titel: string, titel_toevoeging): string {
    return this.formatGA(this.titelToevoegingWeg(titel, titel_toevoeging));
  }

  public static geefVolgnr(vraag: Vraag, reeks: Vraag[]): string {
    if (!vraag || !reeks) {
      return null;
    }
    const volgnummer: number = reeks.filter(v => v.tonen).findIndex(v => v.id === vraag.id) + 1;
    return volgnummer.toString();
  }

  private static titelToevoegingWeg(titel: string, titel_toevoeging): string {
    if (titel_toevoeging?.length > 0) {
      return titel.substring(titel_toevoeging.length);
    }
    return titel;
  }
}
